module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-ext_latin-italic.04e02df1.woff";